
import { 
  Card, 
  CardActionArea, 
  CardContent, 
  CircularProgress, 
  FormControl, 
  Grid, 
  InputLabel, 
  MenuItem, 
  Select, 
  useTheme,
   DialogActions, Button 
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import StudentCardList from './StudentDashboard/StudentCardList';
import { DeviceAlert, StudentCardCountBranch } from '../services/LoginPageService';
import {
  School as SchoolIcon,
  Schedule as ScheduleIcon,
  LocationOn as LocationIcon
} from '@mui/icons-material';
import PeopleIcon from '@mui/icons-material/People';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Paper,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Box
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
// import SchoolIcon from "@mui/icons-material/School";
import { DataGrid } from "@mui/x-data-grid";

const DashboardComponent = () => {
  const theme = useTheme();
  const [dataSet, setDataSet] = useState('');
  const [refreshData, setRefreshData] = useState(false);
  const [dateTime, setDateTime] = useState({
    time: '',
    date: '',
  });
  // Add state for student statistics
  const [studentStats, setStudentStats] = useState({
    total: 23,
    present: 11,
    absent: 12,
  });
  const [open, setOpen] = useState(false);

  const rows = [
    { id: 1, message: "New assignment uploaded", date: "2025-10-10" },
    { id: 2, message: "Attendance updated", date: "2025-10-12" },
  ];
  useEffect(() => {
    const timer = setInterval(() => {
      const currentTime = new Date();
      setDateTime(() => {
        return {
          time: currentTime.toLocaleTimeString('en', {
            hour: 'numeric', 
            hour12: true, 
            minute: 'numeric', 
            second: 'numeric',
          }),
          date: currentTime.toLocaleDateString('es-CL')
        };
      });
    }, 1000);
    
    StudentCardCountBranch(handleSuccess, handleStudentCardCountException);
    
    return () => clearInterval(timer);
  }, [refreshData]);

  const handleSuccess = (dataObject) => {
    setDataSet(dataObject?.data);
    // Update student stats with actual data from API
    // For now, using mock data - replace with actual data from API
    setStudentStats({
      total: 1250,
      present: 980,
      absent: 270
    });
  }
  const [alerts, setAlerts] = useState([]);
  // const [loading, setLoading] = useState(false);

  // Columns for DataGrid
  const columns  =  [
    { field: "id", headerName: "ID", width: 80 },
    { field: "alert_type", headerName: "Alert Type", width: 150 },
    { field: "device_id", headerName: "Device ID", width: 150 },
    { field: "message", headerName: "Message", flex: 1 },
    { field: "created_at", headerName: "Created At", width: 200 },
  ];

  const handleStudentCardCountException = () => {}

  const onViewDeviceAlerts = () => {
      // setLoading(true);
      DeviceAlert(handleDeviceAlerts, handleDeviceAlertsException);
    };

  const handleDeviceAlerts = (dataObject) => {
   console.log("Fetched alerts:", dataObject?.data);
    setAlerts(dataObject?.data || []);
  };

   const handleClose = () => {
    setOpen(false);
  };
 


  const handleDeviceAlertsException = (errorStatus, errorMessage) => {
    // setLoading(false);
    console.log("Error fetching device alerts:", errorMessage);
  };

  // When dialog opens, fetch alerts
  const handleOpen = () => {
    setOpen(true);
    onViewDeviceAlerts();
  };

  return (
    <Box sx={{ 
      height: '99vh',
      overflow: 'auto',
      p: 3,
      bgcolor: theme.palette.grey[50]
    }}>
      {/* All 5 Cards in One Row */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {/* College Card - Slimmer */}
        <Grid item xs={12} md={2.4}>
          <Card sx={{ 
            height: '100%',
            borderRadius: 2,
            boxShadow: 3,
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'translateY(-3px)'
            }
          }}>
            <CardActionArea sx={{ height: '100%' }}>
              <CardContent sx={{ p: 2 }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <LocationIcon color="primary" sx={{ fontSize: 30, mb: 1 }} />
                  <Typography 
                    variant="h6" 
                    color="text.primary"
                    sx={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    Sahyadri
                  </Typography>
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ textAlign: 'center' }}
                  >
                    College of Engineering
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
       
        {/* Time Card - Slimmer */}
        <Grid item xs={12} md={2.4}>
          <Card sx={{ 
            height: '100%',
            borderRadius: 2,
            boxShadow: 3,
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'translateY(-3px)'
            }
          }}>
            <CardActionArea sx={{ height: '100%' }}>
              <CardContent sx={{ p: 2 }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <ScheduleIcon color="secondary" sx={{ fontSize: 30, mb: 1 }} />
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ textAlign: 'center' }}
                  >
                    {dateTime.date}
                  </Typography>
                  <Typography 
                    variant="h6" 
                    color="primary"
                    sx={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {dateTime.time}
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Total Students Card - Slimmer */}
        <Grid item xs={12} md={2.4}>
          <Card sx={{ 
            borderRadius: 2,
            boxShadow: 3,
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'translateY(-3px)'
            }
          }}>
            <CardContent sx={{ p: 2 }}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <PeopleIcon color="primary" sx={{ fontSize: 30, mb: 1 }} />
                <Typography 
                  variant="body2" 
                  color="text.primary"
                  sx={{ fontWeight: 'bold', textAlign: 'center' }}
                >
                  Total Students
                </Typography>
                {/* <Typography 
                  variant="h5" 
                  color="primary"
                  sx={{ fontWeight: 'bold', textAlign: 'center' }}
                >
                  {studentStats.total}
                </Typography> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Present Students Card - Slimmer */}
        <Grid item xs={12} md={2.4}>
          <Card sx={{ 
            borderRadius: 2,
            boxShadow: 3,
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'translateY(-3px)'
            }
          }}>
            <CardContent sx={{ p: 2 }}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <CheckCircleIcon color="success" sx={{ fontSize: 30, mb: 1 }} />
                <Typography 
                  variant="body2" 
                  color="text.primary"
                  sx={{ fontWeight: 'bold', textAlign: 'center' }}
                >
                  Present Today
                </Typography>
                {/* <Typography 
                  variant="h5" 
                  color="success.main"
                  sx={{ fontWeight: 'bold', textAlign: 'center' }}
                >
                  {studentStats.present}
                </Typography> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Absent Students Card - Slimmer */}
        <Grid item xs={12} md={2.4}>
          <Card sx={{ 
            borderRadius: 2,
            boxShadow: 3,
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'translateY(-3px)'
            }
          }}>
            <CardContent sx={{ p: 2 }}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <CancelIcon color="error" sx={{ fontSize: 30, mb: 1 }} />
                <Typography 
                  variant="body2" 
                  color="text.primary"
                  sx={{ fontWeight: 'bold', textAlign: 'center' }}
                >
                  Absent Today
                </Typography>
                {/* <Typography 
                  variant="h5" 
                  color="error.main"
                  sx={{ fontWeight: 'bold', textAlign: 'center' }}
                >
                  {studentStats.absent}
                </Typography> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Student Card List Section */}
      {/* <Paper elevation={2} sx={{ 
        p: 3, 
        borderRadius: 2,
        bgcolor: 'background.paper'
      }}>
        <Typography 
          variant="h5" 
          sx={{ 
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold'
          }}
        >
          <SchoolIcon color="primary" sx={{ mr: 1 }} />
          Student Dashboard
        </Typography>
        <StudentCardList />
      </Paper> */}
      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "background.paper",
          position: "relative",
        }}
      >
        {/* Bell Icon */}
        <IconButton
          onClick={handleOpen}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "primary.main",
          }}
        >
          <NotificationsIcon />
        </IconButton>

        {/* Header */}
        <Typography
          variant="h5"
          sx={{
            mb: 3,
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
          }}
        >
          <SchoolIcon color="primary" sx={{ mr: 1 }} />
          Student Dashboard
        </Typography>

        {/* Student Card List */}
        <StudentCardList />
      </Paper>

      {/* Dialog for Device Alerts */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Device Alerts</DialogTitle>
        <DialogContent>
            <Box sx={{ height: 400, mt: 1 }}>
              <DataGrid
                rows={alerts}
                columns={columns}
                getRowId={(row) => row.id}   // 👈 Important line
                pageSize={5}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
              />
            </Box>
        </DialogContent>
          <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
        
      </Dialog>
    
    </Box>
  )
}

export default DashboardComponent;